import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-note-level',
  templateUrl: './note-level.component.html',
  styleUrls: ['./note-level.component.scss']
})
export class NoteLevelComponent {
  @Input() levelFilter: number;
  @Input() readOnly: boolean;
  @Input() small: boolean;
  @Output() action = new EventEmitter();

  handleLevelChange(l) {
    if (this.readOnly) {
      return;
    }
    this.levelFilter = l;
    this.action.emit(l);
  }
}
